import { render, staticRenderFns } from "./TaskApplicationsPage.vue?vue&type=template&id=9091b88a&"
import script from "./TaskApplicationsPage.vue?vue&type=script&lang=js&"
export * from "./TaskApplicationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports